<template>
    <div class="fhv-centent">
        <h4 class="title-topic">WIFI Basic Settings</h4>
        <el-alert title="Some parameters in subRouter mode are forbidden to be modified!" type="warning" show-icon
        :closable="false" v-if="$G_DEVICE_CFG.isSubRouter"></el-alert>
        <el-form 
        :model="wlform"  
        label-width="180px" 
        label-position="left"
        class="fhv-form" 
        size="mini"
        :rules="formCheck" 
        ref="wlform"
        :disabled="$G_DEVICE_CFG.isReadOnly || $G_DEVICE_CFG.isSubRouter"
        v-loading="getLoad"
        >
            <!-- 2.4G -->
            <h4 class="title-topic" v-if="!$G_DEVICE_CFG.isWlBandSteering">2.4GHz</h4>
            <el-form-item :label="$G_DEVICE_CFG.isWlBandSteering ? 'Enable WLAN' : 'Enable WLAN 2.4GHz:'">
                <el-tooltip :disabled="!$G_DEVICE_CFG.isFindSubRouter" effect="dark" popper-class="wring-text"  placement="top" 
                content="Modifying this parameter may cause the subRouter network to be down. Prohibit operation!">
                <el-switch v-model="wlform.wl1.enable" @change="setWlEnabelData(1)" 
                :disabled="$G_DEVICE_CFG.isFindSubRouter"></el-switch>
                </el-tooltip>
            </el-form-item>
            <div v-show="wlform.wl1.enable">
            <el-form-item label="SSID :" prop="wl1.SSID">
                <el-input v-model.trim="wlform.wl1.SSID"></el-input>
            </el-form-item>
            <el-form-item label="Authentication :" >
                <el-select v-model="wlform.wl1.authMode" style="width: 100%" placeholder="Please select authentication mode">
                    <el-option label="OPEN" :value="0"></el-option>
                    <el-option label="WPA PSK" :value="2"></el-option>
                    <el-option label="WPA2 PSK" :value="4"></el-option>
                    <el-option label="WPA PSK/WPA2 PSK MIXED" :value="6"></el-option>
                </el-select>
            </el-form-item>

            <div v-if="parseInt(wlform.wl1.authMode) > 1">
                <el-form-item label="WPA Preshare key :" prop="wl1.password">
                    <el-input :type="is1ShowKey ? 'text' : 'password'" v-model.trim="wlform.wl1.password">
                        <i slot="suffix" class="el-input__icon glyphicon  fhv-password" 
                        :class="[is1ShowKey ? 'glyphicon-eye-close' : 'glyphicon-eye-open']"
                        @click="is1ShowKey = !is1ShowKey"></i>
                    </el-input>
                </el-form-item>
            </div>
            <el-form-item label="Hide SSID :">
                <el-switch v-model="wlform.wl1.hiddenSSID"></el-switch>
            </el-form-item>
            <el-form-item label="Transmit Power :" >
                <el-select v-model="wlform.wl1.power" 
                @change="tip1Reboot"
                style="width: 100%" placeholder="Please select Transmit Power" >
                    <el-option label="Standard" :value="0"></el-option>
                    <el-option label="Medium" :value="1"></el-option>
                    <el-option label="High" :value="2"></el-option>
                </el-select>
            </el-form-item>
            </div>
            <!-- 5G -->
            <div v-if="!$G_DEVICE_CFG.isWlBandSteering">
                <h4 class="title-topic">5GHz</h4>
                <el-form-item label="Enable WLAN 5GHz">
                    <el-tooltip :disabled="!$G_DEVICE_CFG.isFindSubRouter" effect="dark" popper-class="wring-text"  placement="top" 
                    content="Modifying this parameter may cause the subRouter network to be down. Prohibit operation!">
                    <el-switch v-model="wlform.wl0.enable" @change="setWlEnabelData(0)" 
                    :disabled="$G_DEVICE_CFG.isFindSubRouter"></el-switch>
                    </el-tooltip>
                </el-form-item>
                <div v-show="wlform.wl0.enable">
                <el-form-item label="SSID :">
                    <el-input  v-if="!is5GRepeat" v-model.trim="wl0SSID" :disabled="true"></el-input>
                    <el-input  v-if="is5GRepeat" v-model.trim="wlform.wl0.SSID" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="Authentication :" >
                    <el-select :disabled="true" v-model="wlform.wl1.authMode" style="width: 100%" placeholder="Please select authentication mode">
                        <el-option label="OPEN" :value="0"></el-option>
                        <el-option label="WPA PSK" :value="2"></el-option>
                        <el-option label="WPA2 PSK" :value="4"></el-option>
                        <el-option label="WPA PSK/WPA2 PSK MIXED" :value="6"></el-option>
                    </el-select>
                </el-form-item>

                <div v-if="parseInt(wlform.wl1.authMode) > 1">
                    <el-form-item label="WPA Preshare key :" >
                        <el-input v-if="!is5GRepeat" :disabled="true" :type="is0ShowKey ? 'text' : 'password'" v-model.trim="wlform.wl1.password" >
                            <i slot="suffix" class="el-input__icon glyphicon  fhv-password" 
                            :class="[is0ShowKey ? 'glyphicon-eye-close' : 'glyphicon-eye-open']"
                            @click="is0ShowKey = !is0ShowKey"></i>
                        </el-input>
                        <el-input v-if="is5GRepeat" :disabled="true" :type="is0ShowKey ? 'text' : 'password'" v-model.trim="wlform.wl0.password" >
                            <i slot="suffix" class="el-input__icon glyphicon  fhv-password" 
                            :class="[is0ShowKey ? 'glyphicon-eye-close' : 'glyphicon-eye-open']"
                            @click="is0ShowKey = !is0ShowKey"></i>
                        </el-input>
                    </el-form-item>
                </div>
                <el-form-item label="Hide SSID :">
                    <el-switch v-model="wlform.wl0.hiddenSSID"></el-switch>
                </el-form-item>
                <el-form-item label="Transmit Power :" >
                    <el-select v-model="wlform.wl0.power" 
                    @change="tip0Reboot"
                    style="width: 100%" placeholder="Please select Transmit Power" >
                        <el-option label="Standard" :value="0"></el-option>
                        <el-option label="Medium" :value="1"></el-option>
                        <el-option label="High" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                </div>
            </div>
            <el-form-item>
                <el-button type="primary" @click="apply">Apply</el-button>
                <el-button type="primary" @click="refresh">Refresh</el-button>
            </el-form-item>
        </el-form>
    </div>
    
</template>

<script>
import validator from 'validator'
import devConfig from '@/devConfig'
import sizeof from '@/util/jsCharLength.js'

let power1Cache = '0'; // 2.4G 当前配置 power
let power0Cache = '0'; // 5G 当前配置 power
export default {
    data(){
       return {
           is1ShowKey:false,
           is0ShowKey:false,
           getLoad:false,
           is5GRepeat:false,//5G是否中继成功
           wlform:{
               wl1:{ //2.4G
                   enable:true,
                   SSID:'',
                   password:'',
                   authMode:6,
                   hiddenSSID:false,
                   power: 0,
               },
               wl0:{ //5G
                   enable:true,
                   hiddenSSID:false,
                   power: 0,
                   SSID:'',
                   password:''
               },
           },
           formCheck:{
               wl1:{
                   SSID:[
                        { required: true, message: 'Please enter SSID name', trigger: 'blur' },
                        { 
                            validator:(rule, value, callback) => {
                                if(sizeof(value,'utf-8') > 30 || sizeof(value,'utf-8') < 1)
                                    callback(new Error("SSID name cannot be longer than 30 byte"))
                                else
                                    callback()
                            },
                            trigger: 'blur' 
                        }
                    ],
                   password:[
                        { required: true, message: 'Please enter WPA Preshare key', trigger: 'blur' },
                        { 
                            validator:(rule, value, callback) => {
                                if(sizeof(value,'utf-8') > 64 || sizeof(value,'utf-8') < 8)
                                    callback(new Error("WPA Preshare key must 8~64 byte"))
                                else
                                    callback()
                            },
                            trigger: 'blur' 
                        }
                    ],
               }
                
           } 
       }
    },
    created(){
        devConfig.init(this,()=>{
            this.getData();
        })
        
    },
    computed:{
        wl0SSID(){
            return this.wlform.wl1.SSID + '_5G'
        }
    },
    methods:{
        getData(){
            this.getLoad = true
            axios
            .post("/JSONAPI",{
                cmdType:"CLARO_GET_WLAN_BASIC",

            })
            .then((response)=>{
                this.getLoad = false
                if(response.data.ret == '0')
                {
                    this.wlform.wl1.enable = response.data.wl1.enable
                    this.wlform.wl1.SSID = response.data.wl1.SSID
                    this.wlform.wl1.password = response.data.wl1.password
                    this.wlform.wl1.authMode = response.data.wl1.authMode
                    this.wlform.wl1.hiddenSSID = response.data.wl1.hiddenSSID
                    this.wlform.wl1.power = response.data.wl1.power
                    power1Cache = response.data.wl1.power
                    this.wlform.wl0.enable = response.data.wl0.enable
                    this.wlform.wl0.hiddenSSID = response.data.wl0.hiddenSSID
                    this.wlform.wl0.power = response.data.wl0.power
                    this.wlform.wl0.SSID = response.data.wl0.SSID
                    this.wlform.wl0.password = response.data.wl0.password
                    this.is5GRepeat = response.data.wrepeat.RepeatStatus
                    power0Cache = response.data.wl0.power
                    
                }
            })
        },
        setData(){
            const loadingInstance = this.$loading({lock: true})
            let postData = {
                cmdType:"CLARO_SET_WLAN_BASIC",
                wl1:{
                    SSID:this.wlform.wl1.SSID,
                    password:this.wlform.wl1.password,
                    authMode:this.wlform.wl1.authMode,
                    hiddenSSID:this.wlform.wl1.hiddenSSID,
                    power:this.wlform.wl1.power,
                },
                wl0:{
                    SSID:this.wl0SSID,
                    authMode:this.wlform.wl1.authMode,
                    password:this.wlform.wl1.password,
                    hiddenSSID:this.wlform.wl0.hiddenSSID,
                    power:this.wlform.wl0.power,
                }
            }


            axios
            .post("/JSONAPI",postData)
            .then((response)=>{
                setTimeout(()=>{
                    loadingInstance.close()
                    if(response.data.ret == '0')
                        this.$message.success("Configuration is successful!")
                    else
                        this.$message.error("Configuration failed!")
                },6000)
            })
        },
        apply(){
            this.$refs['wlform'].validate((valid) => {
                if (valid) {
                    this.setData()
                } else {
                    return false
                }
            })
        },
        refresh(){
            this.isShowKey = false
            this.$refs['wlform'].resetFields()
            this.getData()
        },
        setWlEnabelData(index){
            const loadingInstance = this.$loading({lock: true})
            let postData = {
                cmdType:"HOME_SET_WLAN_ENABLE",
                wlIndex:index
            }

            if(index === 1)
                postData.wlEnable = this.wlform.wl1.enable
            else
                postData.wlEnable = this.wlform.wl0.enable

            axios
            .post("/JSONAPI",postData)
            .then((response)=>{
                setTimeout(()=>{
                    loadingInstance.close()
                    if(response.data.ret == '0')
                        this.$message.success("Configuration is successful!")
                    else
                        this.$message.error("Configuration failed!")
                },3000)
            })

        },
        tip1Reboot(val){
            if(val !== power1Cache)
            {
                this.$alert('To modify transmission power parameters, the device shall be restarted before it can take effect. If necessary, please restart the device manually.', 'Warning', {
                    confirmButtonText: 'Confirm',
                    type: 'warning'
                })
            }
        },
        tip0Reboot(val){
            if(val !== power0Cache)
            {
                this.$alert('To modify transmission power parameters, the device shall be restarted before it can take effect. If necessary, please restart the device manually.', 'Warning', {
                    confirmButtonText: 'Confirm',
                    type: 'warning'
                })
            }
        },
    },
}
</script>

<style>
.fhv-password{
    cursor:pointer
}
</style>
